import React, { useRef } from 'react';
import styled from "styled-components";


const Wrapper = styled.form`
    background-color: #814b0c;
    border: 2px solid #000;
    height: 90%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    padding: .7rem;
    gap: .6rem;
    width: 50%;
`
const InputWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: #aeacac;
    padding: 4px;
    border: 1px solid #2e2c2c;
    box-shadow: 4px 4px 1px #373333;
    border-radius: 8px;
    padding-block: 1rem;

    label{
        font-weight: bold;
        font-size: .9rem;
    }
`
const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2.5rem;
`
const Input = styled.input`
    outline: none;
    border: 1px solid #000000;
    height: 40px;
    border-radius: 6px;
    cursor: pointer;
    padding: 4px;
`
const Button = styled.button`
    cursor: pointer;
`
function Variables({setWellData}) {
  const wellData = {
    res_pressure: 0,
    solution_gor: 0,
    Yo: 0,
    Yg: 0,
    res_temp: 0,
    drain_area: 0,
    wellbore_radius: 0,
    res_thickness: 0,
    shape_factor: 0,
    skin: 0,
    perm_k: 0,
    AOF: 0,
  };
  const res_pressure_ref = useRef(null);
  const solution_gor_ref = useRef(null);
  const Yo_ref = useRef(null);
  const Yg_ref = useRef(null);
  const res_temp_ref = useRef(null);   
  const drain_area_ref = useRef(null);
  const wellbore_radius_ref = useRef(null);
  const res_thickness_ref = useRef(null);
  const shape_factor_ref = useRef(null);
  const skin_ref = useRef(null);
  const perm_k_ref = useRef(null);
  const AOF_ref = useRef(null);
  return (
    <Wrapper>
      <Container>
        <InputWrapper>
        <label>Reservoir Pressure (psia)</label>
        <Input type='number' ref={res_pressure_ref} step='any'></Input>
        </InputWrapper>
        <InputWrapper>
        <label>Oil API Gravity (deg API)</label>
        <Input type='number' ref={Yo_ref} step='any'></Input>
        </InputWrapper>
        <InputWrapper>
        <label>Reservoir Temperature (deg F)</label>
        <Input type='number' ref={res_temp_ref} step='any'></Input>
        </InputWrapper>
        <InputWrapper>
        <label>Reservoir Thickness (ft)</label>
        <Input type='number' ref={res_thickness_ref} step='any'></Input>
        </InputWrapper>
        <InputWrapper>
        <label>Shape Factor</label>
        <Input type='number' ref={shape_factor_ref} step='any' value={31.62} disabled></Input>
        </InputWrapper>
        <InputWrapper>
        <label>Permeability (md)</label>
        <Input type='number' ref={perm_k_ref} step='any'></Input>
        </InputWrapper>
      </Container>
      <Container>
      <InputWrapper>
        <label>Solution GOR (SCF/STB)</label>
        <Input type='number' ref={solution_gor_ref} step='any'></Input>
        </InputWrapper>
        <InputWrapper>
        <label>Solution Gas Specific Gravity</label>
        <Input type='number' ref={Yg_ref} step='any'></Input>
        </InputWrapper>
        <InputWrapper>
        <label>Drainage Area (Acres)</label>
        <Input type='number' ref={drain_area_ref} step='any'></Input>
        </InputWrapper>
        <InputWrapper>
        <label>Wellbore Radius (inches)</label>
        <Input type='number' ref={wellbore_radius_ref} step='any'></Input>
        </InputWrapper>
        <InputWrapper>
        <label>Skin</label>
        <Input type='number' ref={skin_ref} step='any'></Input>
        </InputWrapper>
        <InputWrapper>
        <label>Measured AOF<sup>**</sup></label>
        <Input type='number' ref={AOF_ref} step='any' disabled placeholder='ignore'></Input>
        </InputWrapper>
      </Container>
      <InputWrapper>
        <label>Generate IPR<sup>**</sup></label>
        <Button onClick={(e)=>{
            e.preventDefault();
            wellData.res_pressure = Number(res_pressure_ref.current.value);
            wellData.AOF = Number(AOF_ref.current.value);
            wellData.Yg = Number(Yg_ref.current.value);
            wellData.Yo = Number(Yo_ref.current.value);
            wellData.drain_area = Number(drain_area_ref.current.value);
            wellData.perm_k = Number(perm_k_ref.current.value);
            wellData.res_temp = Number(res_temp_ref.current.value);
            wellData.res_thickness = Number(res_thickness_ref.current.value);
            wellData.shape_factor = Number(shape_factor_ref.current.value);
            wellData.skin = Number(skin_ref.current.value);
            wellData.solution_gor = Number(solution_gor_ref.current.value);
            wellData.wellbore_radius = Number(wellbore_radius_ref.current.value);
            setWellData(prev=>[...prev, wellData])
        }}>Generate IPR</Button>
        </InputWrapper>
    </Wrapper>
  )
}

export default Variables
